import React from "react"
import { Navigate } from "react-router-dom"
import Login from "../pages/Authentication/OtpVerify"
import ForgetPwd from "../pages/Authentication/OtpVerify"

import Dashboard from "pages/Dashboard/Dashboard"
import Event from "pages/Event/Event"
import User from "pages/User/User"
import VirtualUsers from "pages/VirtualUsers/VirtualUsers"
import AddVirtualUsers from "pages/VirtualUsers/AddVirtualUsers"
import Leaderboard from "pages/Leaderboard/Leaderboard"
import AddLeaderboardUsers from "pages/Leaderboard/AddLeaderboardUsers"
import UserNotification from "pages/UserNotify/UserNotification"

const authProtectedRoutes = [
  // Dashboard
  { path: "/dashboard", component: <Dashboard /> },

  // Users
  { path: "/users", component: <User /> },

  // Virtual Users
  { path: "/v-users", component: <VirtualUsers /> },

    // User Notify Users
    { path: "/user-notification", component: <UserNotification /> },


    // Add Virtual Users
    { path: "/add-v-users", component: <AddVirtualUsers /> },

      // Leader Board
      { path: "/leader-board", component: <Leaderboard /> },
      { path: "/add-leader-board", component: <AddLeaderboardUsers /> },




  // Events
  { path: "/event", component: <Event /> },

  {
    path: "/admin",
    exact: true,
    component: <Navigate to="/dashboard" />,
  },

  {
    path: "/",
    exact: true,
    component: <Navigate to="/admin" />,
  },
]

const publicRoutes = [
  { path: "/login", component: <Login /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
]

export { authProtectedRoutes, publicRoutes }
